import { render, staticRenderFns } from "./academic-calendar.vue?vue&type=template&id=66a79ef0&scoped=true"
import script from "./academic-calendar.vue?vue&type=script&lang=js"
export * from "./academic-calendar.vue?vue&type=script&lang=js"
import style0 from "./academic-calendar.vue?vue&type=style&index=0&id=66a79ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a79ef0",
  null
  
)

export default component.exports